import moment from "moment";

/** Mesmos presets da tela de comissões — identidade visual e regras alinhadas. */
export type ReportPeriodPreset =
  | "current_month"
  | "last_month"
  | "last_3_months"
  | "custom";

export function computePresetRange(
  preset: Exclude<ReportPeriodPreset, "custom">
): { start: Date; end: Date } {
  const now = moment();
  switch (preset) {
    case "current_month":
      return {
        start: now.clone().startOf("month").toDate(),
        end: now.clone().endOf("day").toDate(),
      };
    case "last_month": {
      const m = now.clone().subtract(1, "month");
      return {
        start: m.clone().startOf("month").toDate(),
        end: m.clone().endOf("month").toDate(),
      };
    }
    case "last_3_months":
      return {
        start: now.clone().subtract(2, "months").startOf("month").toDate(),
        end: now.clone().endOf("day").toDate(),
      };
    default:
      return {
        start: now.clone().startOf("month").toDate(),
        end: now.clone().endOf("day").toDate(),
      };
  }
}

export function parseCustomRange(
  customFrom: string,
  customTo: string
): { start: Date; end: Date } {
  const from = moment(customFrom).startOf("day");
  const to = moment(customTo).endOf("day");
  if (from.isAfter(to)) {
    return { start: to.toDate(), end: from.toDate() };
  }
  return { start: from.toDate(), end: to.toDate() };
}

export function formatPeriodHuman(start: Date, end: Date): string {
  return `${moment(start).format("DD MMM YYYY")} — ${moment(end).format("DD MMM YYYY")}`;
}
